import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import reactSummaryPanelTemplate from '../../templates/current-sale/react-summary-panel.html'
import reactPaymentPanelTemplate from '../../templates/current-sale/react-payment-panel.html'
import paymentPanelTemplate from '../../templates/current-sale/payment-panel.html'
import indexTemplate from '../../templates/current-sale/index.html'
import { ROUTES, STATES } from '../../../lib/routes'

/**
 * =======================================
 * ROUTES CONFIG - CURRENT SALE
 * =======================================
 *
 * @module webregister.routes.current-sale
 */
function CurrentSaleRoutesConfig($stateProvider: StateProvider) {
  /**
   * =======================================
   * VIEWS
   * =======================================
   */
  const views = {
    workspace: {
      template:
        '<react-workspace-component class="wr-current-sale-panel-content"></react-workspace-component>',
    },
    sale: {
      template:
        '<react-sale-root-component class="wr-current-sale-panel-content"></react-sale-root-component>',
    },
    saleSummary: { template: reactSummaryPanelTemplate },
    paymentPanel: {
      template: paymentPanelTemplate,
    },
    payment: { template: reactPaymentPanelTemplate },
    saleConfirmation: {
      template:
        '<react-confirmation-panel class="payment-panel--action"></react-confirmation-panel>',
    },
  }

  /**
   * =======================================
   * STATES
   * =======================================
   */
  $stateProvider
    .state(STATES.CURRENT_SALE, {
      abstract: true,
      template: indexTemplate,
    })
    /*
     * View layout of the current-sale.sale state
     * |--|--------------------------------------|
     * |n |             current-sale             |
     * |a |                                      |
     * |v | |---------------| |----------------| |
     * |  | | current-sale- | | current-sale-  | |
     * |  | | workspace     | | summary        | |
     * |  | |               | |                | |
     * |  | |               | |                | |
     * |  | |               | |                | |
     * |  | |               | |                | |
     * |  | |---------------| |----------------| |
     * |--|--------------------------------------|
     */
    .state(STATES.SALE, {
      url: ROUTES.SALE,
      views: {
        'current-sale-workspace': views.workspace,
        'current-sale-summary': views.sale,
      },
      params: {
        // The sale (or ID thereof) to load (e.g. retrieve a parked/on account/layby sale or load a return)
        sale: null,
        // The action to perform once the sale is loaded (e.g. pay opens the payment dialog)
        action: null,
        closeAfterComplete: false,
        quoteId: null,
        // ABP flow: forwarded from the pay-account-balance API route
        customerId: null,
        onPaymentCompletedRedirectUrl: null,
        // ABP flow: pre-selected payment amount from monocle modal (optional, defaults to full balance)
        amount: null,
      },
    })
    /*
     * View layout of the current-sale.payment-panel state
     * |--|-------------------------------|
     * |n |         current-sale          |
     * |a |                               |
     * |v | |---------------------------| |
     * |  | |        payment-panel      | |
     * |  | | |----------| |----------| | |
     * |  | | | payment- | | payment- | | |
     * |  | | | panel-   | | panel-   | | |
     * |  | | | summary  | | action   | | |
     * |  | | |          | |          | | |
     * |  | | |----------| |----------| | |
     * -----------------------------------|
     */
    .state(STATES.PAYMENT_PANEL, {
      abstract: true,
      views: {
        'payment-panel': views.paymentPanel,
      },
    })
    .state(STATES.PAYMENT, {
      params: {
        lspayQuickPaySelected: false,
      },
      views: {
        'payment-panel-summary': views.saleSummary,
        'payment-panel-action': views.payment,
      },
    })
    .state(STATES.SALE_CONFIRMATION, {
      url: ROUTES.SALE_CONFIRMATION,
      views: {
        'payment-panel-summary': views.saleSummary,
        'payment-panel-action': views.saleConfirmation,
      },
    })
}

angular.module('webregister.routes').config(CurrentSaleRoutesConfig)
